'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseTable = require('@bibliocommons/base-table');

require('../styles/PrintTable.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrintTable(props) {
  return _react2.default.createElement(
    'div',
    { className: 'cp-print-table' },
    _react2.default.createElement(_baseTable.Table, props)
  );
}

exports.default = PrintTable;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/print/lib/components/print-table/components/PrintTable.component.js
// module id = 1450
// module chunks = 1